import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Spinner,
  Row,
  Col,
  FormGroup,
} from "reactstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { baseUrl } from "../../../../Utils/Baseurl/Baseurl";

interface UploadDetailsModalProps {
  isOpen: boolean;
  toggle: () => void;
  tokenId: string;
}

const UploadDetailsModal: React.FC<UploadDetailsModalProps> = ({
  isOpen,
  toggle,
  tokenId,
}) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [quotationNo, setQuotationNo] = useState<string>("");
  const [date, setDate] = useState<string>(
    new Date().toISOString().split("T")[0]
  );
  const [purchaserate, setPurchaserate] = useState<number | "">("");
  const [contents, setContents] = useState<string>("");
  const [existingFile, setExistingFile] = useState<string | null>(null);
  const [medicinename, setMedicinename] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [mrp, setMrp] = useState<string>("");
  const [taxpercentage, setTaxpercentage] = useState<string | "">("");
  const [taxOptions, setTaxOptions] = useState<{ taxpercent: string }[]>([]);

  const [offerdetails, setOfferdetails] = useState<string>("");

  useEffect(() => {
    if (isOpen && tokenId) {
      fetchTaxOptions(); // First, fetch dropdown values
      fetchExistingDetails(); // Then fetch current form data
    }
  }, [isOpen, tokenId]);
  
  useEffect(() => {
    console.log("Updated Contents State:", contents);
  }, [contents]);


  // useEffect(() => {
  //   if (isOpen) {
  //     fetchTaxOptions();
  //   }
  // }, [isOpen]);

  const fetchTaxOptions = async () => {
    try {
      const response = await axios.get(`${baseUrl}tax/getalltax`);
      console.log(response, 'res from tax')
      if (response.data && response.data.data) {
        setTaxOptions(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching tax percentages:", error);
      toast.error("Failed to fetch tax percentages.");
    }
  };

  const fetchExistingDetails = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${baseUrl}medicinedetails/certificates/${tokenId}`
      );
      const data = response.data;
      console.log("API Response:", data);

      if (data) {
        setQuotationNo(data.quotationno || "");
        setPurchaserate(data.purchaserate || "");

        let parsedContents = [];
        if (typeof data.contents === "string") {
          try {
            parsedContents = JSON.parse(data.contents); // Parse if string
          } catch (error) {
            console.error("Error parsing contents:", error);
          }
        } else if (Array.isArray(data.contents)) {
          parsedContents = data.contents;
        }

        console.log("Parsed Contents:", parsedContents); // Debugging
        setContents(parsedContents || []); // Set parsed contents

        setMrp(data.mrp || "");
        setDate(
          data.date
            ? new Date(data.date).toISOString().split("T")[0]
            : new Date().toISOString().split("T")[0]
        );
        setExistingFile(data.indentform || null);
        setMedicinename(data.medicinename || "Unknown Medicine");
        setTaxpercentage(data.taxpercentage || "");
        setOfferdetails(data.offerdetails || "");
        console.log(setTaxpercentage,'setTaxpercentage')
        console.log(setOfferdetails,'setOfferdetails')

      }
    } catch (error) {
      console.error("Error fetching details:", error);
      toast.error("Failed to fetch details.");
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      setSelectedFile(event.target.files[0]);
    }
  };

  const handleUpload = async () => {
    // Validate file is provided
    if (!selectedFile && !existingFile) {
      toast.error("Indent form should be uploaded.");
      return;
    }
    if (Number(purchaserate) > Number(mrp)) {
      toast.error("Purchase Rate cannot be greater than MRP.");
      return;
    }
    const formData = new FormData();
    if (selectedFile) {
      formData.append("indentform", selectedFile);
    } else {
      formData.append("existingFile", existingFile || "");
    }

    formData.append("tokenid", tokenId);
    formData.append("quotationno", quotationNo);
    formData.append("date", date);
    formData.append("purchaserate", purchaserate.toString());
    formData.append("contents", contents);
    formData.append("mrp", mrp);
    formData.append("taxpercentage", taxpercentage);
    formData.append("offerdetails", offerdetails);

    try {
      await axios.post(`${baseUrl}medicinedetails/storeindent`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      toast.success(`Indent Form for ${medicinename} uploaded successfully!`);
      toggle();
    } catch (error: unknown) {
      console.error("Error uploading Indent Form:", error);

      if (error instanceof Error) {
        toast.error(error.message);
      } else {
        toast.error("Failed to upload Indent Form.");
      }
    }


  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      style={{ maxHeight: "80vh" }}
      backdrop="static"
      keyboard={false}
    >

      <ModalHeader toggle={toggle}>Upload Indent Form</ModalHeader>
      <ModalBody>
        {loading ? (
          <div style={{ textAlign: "center" }}>
            <Spinner color="primary" />
            <p>Loading details...</p>
          </div>
        ) : (
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            {/* Medicinename */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <label
                htmlFor="quantity"
                style={{
                  flex: "0 0 30%",
                  marginRight: "10px",
                  fontWeight: "500",
                }}
              >
                Medicine Name:
              </label>
              <Input
                id="medicinename"
                readOnly
                type="text"
                value={medicinename}
                onChange={(e) => setMedicinename(e.target.value)}
                placeholder="Enter quantity"
                style={{ flex: "0 0 65%" }}
              />
            </div>

            {/* Contents Field */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <label
                htmlFor="chemical"
                style={{
                  flex: "0 0 30%",
                  marginRight: "10px",
                  fontWeight: "500",
                }}
              >
                Contents:
              </label>
              <div style={{ flex: "0 0 65%" }}>
                {Array.isArray(contents) && contents.length > 0 ? (
                  contents.map((content, index) => (
                    <FormGroup key={index} className="mb-2">
                      <Row className="align-items-center">
                        <Col md={6}>
                          <Input
                            type="text"
                            placeholder="Content Name"
                            readOnly
                            value={content?.name || "N/A"} // Ensure key exists
                          />
                        </Col>
                        <Col md={6}>
                          <Input
                            type="text"
                            placeholder="Quantity (gms)"
                            readOnly
                            value={content?.quantity || "N/A"} // Ensure key exists
                          />
                        </Col>
                      </Row>
                    </FormGroup>
                  ))
                ) : (
                  <p className="text-center text-muted">
                    No content details added.
                  </p>
                )}
              </div>
            </div>

            {/* Quantity Field */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <label
                htmlFor="quantity"
                style={{
                  flex: "0 0 30%",
                  marginRight: "10px",
                  fontWeight: "500",
                }}
              >
                Quantity:
              </label>
              <Input
                id="quantity"
                type="number"
                value={quotationNo}
                onChange={(e) => setQuotationNo(e.target.value)}
                placeholder="Enter quantity"
                style={{ flex: "0 0 65%" }}
              />
            </div>
            {/* Date Field */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <label
                htmlFor="date"
                style={{
                  flex: "0 0 30%",
                  marginRight: "10px",
                  fontWeight: "500",
                }}
              >
                Date:
              </label>
              <Input
                id="date"
                type="date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                style={{ flex: "0 0 65%" }}
                readOnly
              />
            </div>

            {/* MRP Field */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <label
                htmlFor="mrp"
                style={{
                  flex: "0 0 30%",
                  marginRight: "10px",
                  fontWeight: "500",
                }}
              >
                MRP:
              </label>
              <Input
                id="mrp"
                type="number"
                value={mrp}
                onChange={(e) => setMrp(e.target.value)}
                placeholder="Enter MRP"
                style={{ flex: "0 0 65%" }}
              />
            </div>
            {/* Purchase Rate Field */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <label
                htmlFor="purchaseRate"
                style={{
                  flex: "0 0 30%",
                  marginRight: "10px",
                  fontWeight: "500",
                }}
              >
                Purchase Rate:
              </label>
              <Input
                id="purchaseRate"
                type="number"
                value={purchaserate}
                onChange={(e) => setPurchaserate(Number(e.target.value))}
                placeholder="Enter purchase rate"
                style={{ flex: "0 0 65%" }}
              />
            </div>
            {/* Tax Percentage */}
            <div>
              <label htmlFor="taxpercentage">Tax Percentage:</label>
              <select
                id="taxpercentage"
                value={taxpercentage}
                onChange={(e) => setTaxpercentage(e.target.value)}
                style={{ width: "100%", padding: "8px" }}
              >
                <option value="">Select Tax</option>
                {taxOptions.map((tax) => (
                  <option key={tax.taxpercent} value={tax.taxpercent}>
                    {tax.taxpercent}%
                  </option>
                ))}
              </select>
            </div>

            {/* Offer Details */}
            <Input
              type="textarea"
              value={offerdetails}
              onChange={(e) => setOfferdetails(e.target.value)}
              placeholder="Offer Details"
            />

            {/* File Upload Field */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              {/* Row with label and file input */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                  marginTop: "10px",
                }}
              >
                <label
                  htmlFor="fileInput"
                  style={{ fontWeight: "500", marginRight: "10px" }}
                >
                  Indent Form <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  id="fileInput"
                  type="file"
                  accept=".pdf,.doc,.docx"
                  onChange={handleFileChange}
                />
              </div>
              {/* File information: displayed only if a file is selected or exists */}
              {(selectedFile || existingFile) && (
                <div style={{ marginTop: "5px" }}>
                  {/* Show existing file if present */}
                  {existingFile && (
                    <p
                      style={{
                        marginTop: "10px",
                        color: "#007bff",
                        cursor: "pointer",
                      }}
                    >
                      <a
                        href={`${baseUrl}${existingFile}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View Form
                      </a>
                    </p>
                  )}
                </div>
              )}
            </div>
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="success" onClick={handleUpload} disabled={loading}>
          Upload
        </Button>
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default UploadDetailsModal;
